<script setup>
import { computed } from 'vue';
import { CORES_STATUS_PAGAMENTO_CLT, ICONES_STATUS_PAGAMENTO_CLT } from '@/commons/solicitacaoPagamentoCLT';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_PAGAMENTO_CLT[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_PAGAMENTO_CLT[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
